"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.string.includes");

var _toConsumableArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  border-radius: ", ";\n  display: inline-block;\n  padding: 0 ", ";\n  font-weight: bold;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Markdown = exports.markdownToPlainText = exports.markdownToHtml = exports.HTMLOrMarkdown = void 0;

var hastscript_1 = require("hastscript");

var react_1 = __importDefault(require("react"));

var react_markdown_1 = __importDefault(require("react-markdown"));

var rehype_raw_1 = __importDefault(require("rehype-raw"));

var rehype_stringify_1 = __importDefault(require("rehype-stringify"));

var remark_directive_1 = __importDefault(require("remark-directive"));

var remark_gfm_1 = __importDefault(require("remark-gfm"));

var remark_parse_1 = __importDefault(require("remark-parse"));

var remark_rehype_1 = __importDefault(require("remark-rehype"));

var styled_components_1 = __importDefault(require("styled-components"));

var unified_1 = __importDefault(require("unified"));

var unist_util_visit_1 = __importDefault(require("unist-util-visit"));

var vfile_1 = __importDefault(require("vfile"));

function correctMarkdown(value) {
  // This is to fix deeply-nested lists rendering as code blocks instead.
  return value.replace(/ {4}(?=\d)/g, '     ');
}

function plainText() {
  function compiler(tree) {
    var parts = [];
    (0, unist_util_visit_1["default"])(tree, 'text', function (node) {
      parts.push(node.value);
    });
    return parts.join('');
  }

  Object.assign(this, {
    Compiler: compiler
  });
}

var VALID_TAG_NAMES = 'a,abbr,address,area,article,aside,audio,b,base,bdi,bdo,blockquote,body,br,button,canvas,caption,cite,code,col,colgroup,data,datalist,dd,del,details,dfn,dialog,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,i,iframe,img,input,ins,kbd,label,legend,li,link,main,map,mark,menu,meta,meter,nav,noscript,object,ol,optgroup,option,output,p,param,picture,pre,progress,q,rp,rt,ruby,s,samp,script,section,select,slot,small,source,span,strong,style,sub,summary,sup,table,tbody,td,template,textarea,tfoot,th,thead,time,title,tr,track,u,ul,var,video,wbr'.split(',');

function htmlDirectives() {
  return transform;

  function transform(tree) {
    (0, unist_util_visit_1["default"])(tree, ['textDirective', 'leafDirective', 'containerDirective'], ondirective);
  }

  function ondirective(node) {
    var data = node.data || (node.data = {});
    var hast = (0, hastscript_1.h)(node.name, node.attributes);
    var tagName = hast.tagName;

    if (VALID_TAG_NAMES.includes(tagName)) {
      data.hName = hast.tagName;
      data.hProperties = hast.properties;
    } else {
      data.hName = 'span';
      var attrString = Object.keys(node.attributes || {}).reduce(function (acc, attributeKey) {
        return [].concat(_toConsumableArray(acc), [[attributeKey, node.attributes[attributeKey]].join('=')]);
      }, []).join(',');
      data.hChildren = [{
        type: 'text',
        value: ":".concat(node.name).concat(attrString ? "{".concat(attrString, "}") : '')
      }];
    }
  }
}

function placeholderDirective() {
  return transform;

  function transform(tree) {
    (0, unist_util_visit_1["default"])(tree, ['textDirective', 'leafDirective', 'containerDirective'], function (node) {
      if (node.name === 'placeholder') {
        var data = node.data || (node.data = {});
        data.hName = 'placeholder';
        data.hProperties = {
          name: node.attributes.name
        };
      }
    });
  }
}

function placeholderReplaceDirective(placeholders) {
  return function () {
    return transform;

    function transform(tree) {
      (0, unist_util_visit_1["default"])(tree, ['textDirective', 'leafDirective', 'containerDirective'], function (node) {
        if (node.name === 'placeholder') {
          var data = node.data || (node.data = {});
          data.hName = 'span';
          data.hChildren = [{
            type: 'text',
            value: placeholders[node.attributes.name]
          }];
        }
      });
    }
  };
}

function HTMLOrMarkdown(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  if (children.includes('<p>') && children.includes('</p>') && children.startsWith('<')) {
    return react_1["default"].createElement("div", {
      dangerouslySetInnerHTML: {
        __html: children
      }
    });
  } else {
    return react_1["default"].createElement(Markdown, Object.assign({
      children: children
    }, props));
  }
}

exports.HTMLOrMarkdown = HTMLOrMarkdown;

function markdownToHtml(markdown) {
  var processor = (0, unified_1["default"])().use(remark_parse_1["default"]).use([remark_directive_1["default"], htmlDirectives, remark_gfm_1["default"]]).use(remark_rehype_1["default"], {
    allowDangerousHtml: true
  }).use(rehype_raw_1["default"]).use(rehype_stringify_1["default"]);
  var file = (0, vfile_1["default"])(markdown);
  return String(processor.processSync(file));
}

exports.markdownToHtml = markdownToHtml;

function markdownToPlainText(markdown, placeholders) {
  var processor = (0, unified_1["default"])().use(remark_parse_1["default"]).use([remark_directive_1["default"], htmlDirectives, placeholderReplaceDirective(placeholders || {}), remark_gfm_1["default"]]).use(remark_rehype_1["default"], {
    allowDangerousHtml: true
  }).use(rehype_raw_1["default"]).use(plainText);
  var file = (0, vfile_1["default"])(markdown);
  return String(processor.processSync(file));
}

exports.markdownToPlainText = markdownToPlainText;

function Markdown(_a) {
  var children = _a.children,
      inline = _a.inline,
      placeholders = _a.placeholders,
      props = __rest(_a, ["children", "inline", "placeholders"]);

  if (typeof props.plugins === 'function' && process.env.NODE_ENV === 'development') {
    console.warn('Markdown "plugins" prop cannot be a function.');
  }

  return react_1["default"].createElement(react_markdown_1["default"], Object.assign({
    skipHtml: false
  }, props, {
    components: Object.assign(Object.assign(Object.assign({}, props.components), inline ? {
      p: function p(_a) {
        var node = _a.node,
            props = __rest(_a, ["node"]);

        return react_1["default"].createElement("span", Object.assign({}, props));
      }
    } : {}), {
      placeholder: function placeholder(_a) {
        var name = _a.name,
            rest = __rest(_a, ["name"]);

        if (placeholders === null || placeholders === void 0 ? void 0 : placeholders[name]) {
          return react_1["default"].createElement("span", Object.assign({}, rest, {
            children: placeholders[name]
          }));
        } else {
          return react_1["default"].createElement(NoPlaceholder, Object.assign({}, rest), "No Placeholder");
        }
      }
    }),
    children: correctMarkdown(children),
    plugins: [remark_directive_1["default"], htmlDirectives, placeholderDirective].concat(_toConsumableArray(Array.isArray(props.plugins) ? props.plugins : []), [remark_gfm_1["default"]]),
    rehypePlugins: [rehype_raw_1["default"]],
    linkTarget: '_blank'
  }));
}

exports.Markdown = Markdown;
var NoPlaceholder = styled_components_1["default"].span(_templateObject(), function (props) {
  return props.theme['@gray-2'];
}, function (props) {
  return props.theme['@red'];
}, function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@size-xxs'];
});